import setting from './config.util';

const endPoint = {
  FETCH_EVENTS_SLIDER_BY_PAGE_GUEST: `${setting.APP_BASE_URL}/event/fetch-events-slider-by-page-guest`,
  FETCH_EVENTS_BY_PAGE_GUEST_BY_LOCATION: `${setting.APP_BASE_URL}/event/fetch-events-by-page-guest-by-location`,
  FETCH_EVENTS_BY_CATEGORY_NAME_BY_PAGE_GUEST: `${setting.APP_BASE_URL}/event/fetch-events-by-category-name-by-page-guest`,
  FETCH_EVENTS_BY_CATEGORY_BY_PAGE_GUEST: `${setting.APP_BASE_URL}/event/fetch-events-by-category-by-page-guest`,
  FETCH_TRENDING_EVENTS_BY_PAGE_GUEST_BY_LOCATION: `${setting.APP_BASE_URL}/event/fetch-events-trending-by-page-guest`,
  FETCH_SEARCH_EVENTS: `${setting.APP_BASE_URL}/event/v1/search-global`,
  FETCH_CATEGORY: `${setting.APP_BASE_URL}/event/fetch-category`,
  FETCH_CATEGORY_INFO: `${setting.APP_BASE_URL}/event/fetch-category-info`,
  FETCH_TIME_DATA: `${setting.APP_BASE_URL}/event/fetch-active-times-and-custom`,
  UPDATE_INFLUENCER_VISIT: `${setting.APP_BASE_URL}/event/update-visit-influencer`,
  FETCH_EVENT_INFO: `${setting.APP_BASE_URL}/specific-event/fetch-event-info`,
  SEND_LOGIN_OTP: `${setting.APP_BASE_URL}/auth/send-otp-for-auth`,
  VALIDATE_LOGIN_OTP: `${setting.APP_BASE_URL}/auth/validate-otp-for-auth`,
  EDIT_USER: `${setting.APP_BASE_URL}/user/update-profile`,
  USER_PROFILE: `${setting.APP_BASE_URL}/user/my-profile`,
  // v7 resolves the gateway from admin config (per-event override -> global ->
  // env -> Cashfree) instead of env alone, and is the only version that returns
  // a usable Razorpay order. v6 remains valid and Cashfree-only; do not move
  // back to it without also removing the RZP branch in useCheckout.
  SEAT_VERIFY: `${setting.APP_BASE_URL}/event-payment/v7/process-event-payment`,
  PAYMENT: `${setting.APP_BASE_URL}/event-payment/v1/fetch-payment-status`,
  FETCH_EVENT_DATES: `${setting.APP_BASE_URL}/event/v2/fetch-active-dates`,
  SINGLE_TICKET: `${setting.APP_BASE_URL}/specific-event/fetch-single-ticket`,
  EVENT_BOOKING_DETAILS_API: `${setting.APP_BASE_URL}/specific-event/event-booking-details`,
  SEARCH_LOCATION_API: `${setting.APP_BASE_URL}/search/v2/fetch-addresss-search-results`,
  ADDRESS_LOCATION_API: `${setting.APP_BASE_URL}/search/v1/fetch-addresss-info-public`,
  PASSES_ALL_CHECK_D2C: `${setting.APP_BASE_URL}/event-payment/v1/passes-all-check-d2c`,
  // v7 for the same reason as SEAT_VERIFY above: admin-config gateway
  // resolution plus the fixed Razorpay order path. v5 remains Cashfree-only.
  SEAT_VERIFY_D2C: `${setting.APP_BASE_URL}/event-payment/v7/process-event-payment-d2c`,
  ORDERINFO: `${setting.APP_BASE_URL}/event/v1/fetch-order-status`,
  POST_CONTACT_FORM: `${setting.APP_BASE_URL}/loyaltyCampaign/v1/submit-fydo-contact-us`,
  LANDING_EVENTS: `${setting.APP_BASE_URL}/specific-event/highest-bookings`,
  FETCH_COORDINATE_DETAILS: `${setting.APP_BASE_URL}/area/v3/fetch-coordinate-details`,
  FETCH_ACTIVE_DATES: `${setting.APP_BASE_URL}/event/v3/fetch-active-dates`,
  FETCH_ACTIVE_SLOTS: `${setting.APP_BASE_URL}/event/v1/fetch-active-slots`,
  FETCH_EVENT_TICKETS: `${setting.APP_BASE_URL}/event/v3/fetch-active-tickets`,
};

export default endPoint;
